<template>
	<div class="c-object" :class="objectVariant === 'basic' ? '' : objectVariant">
		<a :href="url">
			<div class="c-object__media" v-if="url">

				<span class="t-visually-hidden">{{ title }}</span>
				<img v-if="image" :src="image" alt="" class="c-object__image" />

			</div>
			<div class="c-object__content" :class="{ 'c-object__content--hasactions': hasActions }">
				<div class="c-object__head" v-if="title || byline">
					<h2 class="c-object__title" v-if="title">{{ title }}</h2>
					<span class="c-object__byline" v-if="byline">{{ byline }}</span>
				</div>
				<div class="c-object__body">
					<p class="c-object__text" v-if="text">{{ text }}</p>
					<p class="c-object__pros" v-if="pros != 0 && pros && pros.text">
						<v-icon name="icon-check" size="s" cssModifiers="c-icon--success"></v-icon>
						{{ pros.text }}
					</p>
					<div class="c-object__info" v-if="info">
						<ul class="c-object__list">
							<li v-for="(i, index) in info" :key="index">
								<span class="c-object__label">{{ i.displayName }}:</span>
								<span class="c-object__value">{{
									i.displayValue
								}}</span>
							</li>
						</ul>
					</div>
				</div>
				<div class="c-object__action" v-if="hasActions">
					<span class="v-object__main-action" :href="mainAction.url">
						<span>{{ mainAction.text }}</span>
						<v-icon :name="getIcon(mainAction.url)" size="xxs"></v-icon>
					</span>

					<a v-for="(button, index) in secondaryActions" :key="index" :href="button.url" class="c-object__action-link">
						<span>{{ button.text }}</span>
						<v-icon :name="getIcon(mainAction.url)" size="xxs"></v-icon>
					</a>
				</div>
			</div>
		</a>
	</div>
</template>

<script>
import VIcon from "../../../components/icon/VIcon.vue";

export default {
	name: "VObject",
	components: {
		VIcon
	},
	props: {
		variant: {
			type: Boolean,
			default: false
		},
		url: {
			type: String
		},
		image: {
			type: String
		},
		title: {
			type: String
		},
		byline: {
			type: String
		},
		text: {
			type: String
		},
		buttons: {
			type: Array,
			default: () => []
		},
		pros: {
			type: Array,
			default: () => []
		},
		published: {
			type: String,
			default: ""
		},
		access: {
			type: String,
			default: ""
		},
		address: {
			type: String,
			default: ""
		},
		info: {
			type: Array,
			default: () => []
		},
		objectType: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			objectVariant: "",
			hasActions: false
		};
	},
	computed:{
		mainAction(){
			return this.buttons[0];
		},
		secondaryActions(){
			if(this.buttons){
				return this.buttons.slice(1,this.buttons.length);
			}

			return [];
		}
	},
	methods: {
		isExternalUrl(url) {
			return /^(http|https|\/\/)/.test(url) && !url.includes(window.location.hostname);
		},
		getIcon(url) {
			return this.isExternalUrl(url) ? "icon-external" : "icon-chevron";
		}
	},
	mounted() {
		if (this.variant) {
			this.objectVariant = "c-object--highlight";
		}

		if(this.buttons){
			this.hasActions = this.buttons.length > 0;
		}
	}
};
</script>
